import i18next from "i18next";

export const changeLanguage = (lng: string) => {
  i18next.changeLanguage(lng);
  // import("i18next").then((module) => {
  //   console.log({ __lng__: module.default.language });
  //   i18next.changeLanguage(module.default.language);
  // });
};
